"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputProto = exports.InputProto = exports.WireType = void 0;
var WireType;
(function (WireType) {
    WireType[WireType["Varint"] = 0] = "Varint";
    WireType[WireType["Bit64"] = 1] = "Bit64";
    WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    WireType[WireType["StartGroup"] = 3] = "StartGroup";
    WireType[WireType["EndGroup"] = 4] = "EndGroup";
    WireType[WireType["Bit32"] = 5] = "Bit32";
})(WireType = exports.WireType || (exports.WireType = {}));
class InputProto {
    setUtf8(value) {
        this.u8 = value;
    }
    static serializeBinary(it) {
        return it.serializeBinary();
    }
    serializeBinary() {
        let buf = [];
        this.uint32(((2 << 3) | WireType.LengthDelimited) >>> 0, buf);
        let txtBytes = this.u8 ? InputProto.textEncode(this.u8) : [];
        this.uint32(txtBytes.length, buf);
        let offset = buf.length;
        let pb = new Uint8Array(offset + txtBytes.length);
        pb.set(buf, 0);
        pb.set(txtBytes, offset);
        return pb;
    }
    uint32(value, buf) {
        while (value > 0x7f) {
            buf.push((value & 0x7f) | 0x80);
            value = value >>> 7;
        }
        buf.push(value);
    }
}
exports.InputProto = InputProto;
InputProto.textEncode = typeof TextEncoder !== 'undefined'
    ? (it) => new TextEncoder().encode(it)
    : (it) => unescape(encodeURIComponent(it))
        .split('')
        .map((val) => val.charCodeAt(0));
function u8decode(u8) {
    var out = '', len = u8.length;
    for (var i = 0, c, h4; i < len;) {
        c = u8[i++];
        if (c > 0x7f) {
            h4 = c >> 4;
            if (h4 == 0b1110) {
                c = ((c & 0x0f) << 12) | ((u8[i++] & 0x3f) << 6) | (u8[i++] & 0x3f);
            }
            else if (h4 >> 1 == 0b110) {
                c = ((c & 0x1f) << 6) | (u8[i++] & 0x3f);
            }
            else if (h4 == 0b1111) {
                c = ((c & 0x07) << 18) | ((u8[i++] & 0x3f) << 12) | ((u8[i++] & 0x3f) << 6) | (u8[i++] & 0x3f);
            }
            else {
                continue;
            }
        }
        out += String.fromCodePoint(c);
    }
    return out;
}
class OutputProto {
    constructor(buf) {
        this.buf = buf;
        this.len = buf.length;
        this.pos = 0;
        this.c = 0;
        while (this.pos < this.len) {
            let tag = this.varint32read(), fieldNo = tag >>> 3, wireType = tag & 7;
            if (fieldNo <= 0 || wireType < 0 || wireType > 5) {
                throw new Error('illegal tag: field no ' + fieldNo + ' wire type ' + wireType);
            }
            switch (fieldNo) {
                case 1:
                    this.c = this.varint32read() | 0;
                    break;
                case 2:
                    this.dc = OutputProto.DataCase.M;
                    this.m = OutputProto.textDecode(this.bytesRead());
                    break;
                case 3:
                    this.dc = OutputProto.DataCase.UTF8;
                    this.utf8 = OutputProto.textDecode(this.bytesRead());
                    break;
                case 4:
                    this.dc = OutputProto.DataCase.BS;
                    this.bs = this.bytesRead();
                    break;
                default:
                    this.skip(wireType);
            }
        }
    }
    static deserializeBinary(buf) {
        return new OutputProto(buf);
    }
    varint32read() {
        let b = this.buf[this.pos++];
        let result = b & 0x7f;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return result;
        }
        b = this.buf[this.pos++];
        result |= (b & 0x7f) << 7;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return result;
        }
        b = this.buf[this.pos++];
        result |= (b & 0x7f) << 14;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return result;
        }
        b = this.buf[this.pos++];
        result |= (b & 0x7f) << 21;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return result;
        }
        b = this.buf[this.pos++];
        result |= (b & 0x0f) << 28;
        for (let readBytes = 5; (b & 0x80) !== 0 && readBytes < 10; readBytes++)
            b = this.buf[this.pos++];
        if ((b & 0x80) != 0)
            throw new Error('invalid varint');
        this.assertBounds();
        return result >>> 0;
    }
    assertBounds() {
        if (this.pos > this.len)
            throw new RangeError('premature EOF');
    }
    bytesRead() {
        let len = this.varint32read();
        let start = this.pos;
        this.pos += len;
        return this.buf.subarray(start, start + len);
    }
    skip(wireType) {
        let start = this.pos;
        switch (wireType) {
            case WireType.Varint:
                while (this.buf[this.pos++] & 0x80) {
                }
                break;
            case WireType.Bit64:
                this.pos += 4;
            case WireType.Bit32:
                this.pos += 4;
                break;
            case WireType.LengthDelimited:
                let len = this.varint32read();
                this.pos += len;
                break;
            default:
                throw new Error('cant skip wire type ' + wireType);
        }
        this.assertBounds();
        return this.buf.subarray(start, this.pos);
    }
    getDataCase() {
        return this.dc;
    }
    getC() {
        return this.c;
    }
    getM() {
        return this.m;
    }
    getUtf8() {
        return this.utf8;
    }
    getBs() {
        return this.bs;
    }
}
exports.OutputProto = OutputProto;
OutputProto.textDecode = typeof TextDecoder !== 'undefined'
    ? (it) => new TextDecoder('utf-8').decode(it)
    : u8decode;
(function (OutputProto) {
    let DataCase;
    (function (DataCase) {
        DataCase[DataCase["DATA_NOT_SET"] = 0] = "DATA_NOT_SET";
        DataCase[DataCase["M"] = 2] = "M";
        DataCase[DataCase["UTF8"] = 3] = "UTF8";
        DataCase[DataCase["BS"] = 4] = "BS";
    })(DataCase = OutputProto.DataCase || (OutputProto.DataCase = {}));
})(OutputProto = exports.OutputProto || (exports.OutputProto = {}));
